const report = {
  sellReport: 'analytics/userdietorder',
  zirehReports: 'analytics/user-and-order',
  ticketReports: 'analytics/ticket',
  totalUser: 'analytics/paiduser',
}
export default report
